/**
 * address Group
 * @param fb : FormBuilder
 */
export function convocationGroup (fb: any):any {
    return fb.group({
        text: fb.control(''),
        carrier: fb.group({
            text: fb.control('')
        })
    });
}
